import React from 'react';
import ATable from '../../common/table';

const DisputeRegionsTable = (props) => {
    
 
    const columns = [{
        header: "S/N",
        width: 50,
        render :  row => (<div>{props.paginatedCallBack(row.viewIndex)}</div>)
    }, 
    {
        header: "Name",
        accessor: "name"
    },
    {
        header: "Period Type",
        accessor: "periodType",
    },
    {
        header: "Country",
        accessor: "country",
    }
    ];
    return (
            <ATable
                className="-striped -highlight"
                    tableData={props.disputeRegions}
                    columns={columns}
                    onChange={props.onTableChange || null}     
                    manual
                    {...props} />
    )
};

export default DisputeRegionsTable;


// WEBPACK FOOTER //
// ./src/components/admin/disputeRegions/disputeRegionsTable.js